import React from 'react';
import Flex from './Flex';
import { useNavigate } from 'react-router-dom';
import Typography from './Typographys';
import { TYPOGRAPHY } from '../../constants';
import { settingsDirection } from '../../assets';

function SettingsNavigateItem({ props }) {
  const navigate = useNavigate();
  return (
    <>
      <Flex
        className="border-[2px] border-purple-600 rounded-md py-3 px-4 cursor-pointer max-w-96"
        onClick={
          props.onclick
            ? props.onclick
            : () => {
                navigate(`${props?.to}`);
              }
        }
        justify="space-between"
        align="center"
      >
        <Typography
          text={props?.title}
          type={TYPOGRAPHY.SUBTITLE}
          className="!font-bold"
        />
        <img src={settingsDirection} alt="settingsDirection" />
      </Flex>
    </>
  );
}

export default SettingsNavigateItem;
